import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import download from 'downloadjs'
import router from '../../../router'
export default {
  name: 'shipment',
  components: {
    Paginate,
    DatePicker,
    VueElementLoading,
  },
  props: ['selectedRow', 'filterData','searchflag'],

  data() {
    return {
      toValidateArr: [],
      isfetchResult: false,
      isOrderSR: false,
      isvalidated: false,
      msg: '',
      ShipCancelShow: false,
      reverseAWB: "",
      clientdata: [],
      //
      listClientData: [],
      listWarehouseData: [],
      clientid: '',
      client: '',
      warehouseid: '',
      warehouse: '',
      ClientErr: '',
      WarehouseErr: '',
      ClientErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      loginuserid: '',
      isLoading: false,
      displayCancel: false,
      dublicatemsg: false,
      isqtycheck: false,
      //
      loginuseremail: '',
      invalidOrder: false,
      invalidOrderErr: '',
      searchchannel: '',
      transporterList: [],
      salesOrder: '',
      clientRtrnId: '',
      searchransporter: '',
      returnWarehouse: '',
      reverseAWBErr: '',
      salesOrderErr: '',
      transporterErr: '',
      emptyErrMsg: '',
      SRLineItemsListArr: [{
        "productname": "",
        "productid": '',
        "qnty": '',
        "isvalidateprodid": false,
        "isvalidateqnty": false,
      }],
      merchantid : 0,
    }
  },

  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    this.listClientData = '';
    var permissionEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    var roleids = userdetail.roleid.split(',');
    for (var i = 0; i < roleids.length; i++) {
      if (roleids[i] == 40) {
        this.purchasingManager = parseInt(userdetail.roleid);
        this.isTrue = true;
      }
    }
    this.loginuserid = userdetail.userid;
    this.loginuseremail = userdetail.email;
    this.pageNo = 0;
    // User access conditions
    if (userdetail.roleid == 1 || userdetail.roleid == 4) {
      this.displayCancel = true
    }
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    this.getSalesChannels()
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;
      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }

  }, // End computed
  methods: {
    showList() {
      if((this.searchflag !=undefined && this.searchflag !='') || this.searchflag==false){
       this.$emit("goBackToParent")
      }
      else{
       this.$router.push({
         path: '/srmaster'
       })
      }
    },
    addRow() {
      this.SRLineItemsListArr.push({
        "productname": "",
        "productid": '',
        "qnty": 0
      });
    },
    getSalesChannels() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      if (this.clientid == '') {
        this.WarehouseErr = this.$t('common.clientError');
        return false;
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'courierMasterList',
          'data': {
            clientid: this.client

          },
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.transporter = []
          this.transporterList = result.data.data.rows;
        }, error => {
          console.error(error);
        });
    },

    // getClientList() {
    //   this.listClientData = '';
    //   var userToken = window.localStorage.getItem('userToken');
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageno = 0;

    //   if (this.warehouseid)
    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });
    //   else {
    //     this.input = {};
    //   }
    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //     .then(result => {
    //       this.listClientData = result.data.data;
    //     }, error => {
    //       console.error(error);
    //     });
    // },

    // getWarehouseList() {
    //   var userToken = window.localStorage.getItem('userToken')
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageno = 0;
    //   this.input = ({
    //     clientid: this.clientid,
    //   });
    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //     .then(result => {
    //       this.listWarehouseData = result.data.data;
    //     }, error => {
    //       console.error(error)
    //     })
    // },
    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.reset(0);
    //     this.clientid = this.client;
    //     if (this.clientid)
    //       this.getSalesChannels();
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     }
    //   }
    // },

    // warehouseSelected() {
    //   if (this.warehouseid != this.warehouse) {
    //     this.reset(0);
    //     this.warehouseid = this.warehouse;
    //     this.pageno = this.pageCount = 0;
    //     if (this.warehouseid) {
    //       if (this.clientid) {
    //         this.getSalesChannels();
    //       } else {
    //         this.getClientList();
    //       }
    //     }
    //   }
    // },
    transporterSelected() {
      if (this.isvalidated) {
        this.reset(1)
      }
    },
    clickOnReverseAWB() {
      if (this.isvalidated) {
        this.reset(1)
      }
    },

    reset(cnd) {
      //alert("called");
      this.transporterErr = '';
      this.reverseAWBErr = '';
      this.WarehouseErr = '';
      this.ClientErr = '';
      this.invalidOrderErr = '';
      this.salesOrderErr = '';
      this.dublicatemsg = false;
      this.isfetchResult = false;
      this.salesOrder = '';
      this.searchchannel = '';
      document.getElementById('clientRtrnId').value = ''
      document.getElementById('salesOrder').value = ''
      document.getElementById('reverseAWB').value = ''
      this.reverseAWB = '';
      this.clientRtrnId = '';
      if (cnd) {
        if (this.user_type == 'warehouse_user')
          this.client = '';
        else if (this.user_type == 'client_user')
          this.warehouse = '';
        else {
          this.client = '';
          this.warehouse = '';
        }
      }
      this.SRLineItemsListArr = [{
        "productname": "",
        "productid": '',
        "qnty": '',
        "isvalidateprodid": false,
        "isvalidateqnty": false,
      }]
      this.isvalidated = false;
      document.getElementById('addlinebtn').disabled = false;
    },

    deleterow(index, dindex) {
      this.dublicatemsg = false;
      if (this.SRLineItemsListArr.length > 1) {
        var index1 = this.SRLineItemsListArr.findIndex(x => (x.productid == index.productid));
        this.SRLineItemsListArr.splice(dindex, 1);
      }
    },
    validateSalesOrder() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.orderShipShow = false;
      if (localStorage.getItem("selectedClient") == '') {
        this.$alertify.error("Please select client");
        return false;
      }
      if (this.salesOrder == '') {
        return false;
      }
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "orderid": this.salesOrder.trim()
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'validateSalesOrder',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          // if (this.isvalidated) {
          //   this.reset(1)
          // }
          if (result.data.errorCode == 0) {
            this.merchantid = result.data.data.merchantid != null ? result.data.data.merchantid : 0;
            this.invalidOrder = false
            this.invalidOrderErr = ''
            this.ToValidateSRData();
            //this.$alertify.success(result.data.msg);
          } else {
            this.invalidOrder = true
            this.invalidOrderErr = this.$t('createsr.invalidOrderError');
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
    validatereverseAWB() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      if (localStorage.getItem("selectedClient") == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      this.input = {
        "reverseawb": this.reverseAWB.trim(),
        "couriername": this.searchchannel,
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'validateReverseAWB',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          if (this.isvalidated) {
            this.reset(1)
          }
          if (result.data.errorCode == 0) {
            this.isvalidated = true
            this.$alertify.success(result.data.msg);
            document.getElementById('addlinebtn').disabled = true;
          } else {
            document.getElementById('addlinebtn').disabled = false;
            this.$alertify.error(result.data.msg);
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
    validate() {
      document.getElementById('addlinebtn').disabled = true;
      if (localStorage.getItem("selectedClient") == '') {
        this.ClientErr = this.$t('common.clientError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else if (localStorage.getItem("selectedWarehouse") == '') {
        this.WarehouseErr = this.$t('common.warehouseError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else if (this.reverseAWB == '') {
        this.reverseAWBErr = this.$t('createsr.reverseAWBError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else if (this.searchchannel == '') {
        this.transporterErr = this.$t('createsr.transporterError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else if (this.salesOrder == '') {
        this.salesOrderErr = this.$t('createsr.salesOrderError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else if (this.salesOrder != '' && this.invalidOrder) {
        this.invalidOrderErr = this.$t('createsr.invalidOrderError');
        document.getElementById('addlinebtn').disabled = false;
        return false;
      } else {
        this.validatereverseAWB()
      }
    },
    validateProduct(data, index) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.isqtycheck = false
      this.emptyErrMsg = ''
      this.SRLineItemsListArr[index].productErr = ''
      this.SRLineItemsListArr[index].qtyErr = ""

      if (localStorage.getItem("selectedClient") == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      if (data.productid == '') {
        this.SRLineItemsListArr[index].productErr = this.$t('createsr.productIdEANPlaceholder');
        return false;
      }
      this.dublicatemsg = false;
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "productid": data.productid.toString(),
        "orderid": this.salesOrder.trim()
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'validateProduct',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          if (result.data.errorCode == 0) {
            this.SRLineItemsListArr[index].productname = result.data.data.productname;
            // if (result.data.orderqnty) {
            //   this.SRLineItemsListArr[index].ordqtyt = Number(result.data.orderqnty[0])
            // }
            this.SRLineItemsListArr[index].productErr = ''
            this.SRLineItemsListArr[index].isvalidateprodid = true
            // this.isvalidated = true
            //this.$alertify.success(result.data.msg);
          } else {
            this.SRLineItemsListArr[index].productname = '';
            this.SRLineItemsListArr[index].qnty = '';
            this.SRLineItemsListArr[index].productErr = this.$t('createsr.invalidProductError');
            this.SRLineItemsListArr[index].isvalidateprodid = false
            //this.$alertify.error(result.data.msg);
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
    validateqnty(data, index) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      if (data.productid == '') {
        this.isqtycheck = false
        this.SRLineItemsListArr[index].qtyErr = ""
        this.SRLineItemsListArr[index].productErr = this.$t('createsr.productIdEANPlaceholder');
        return false;
      }
      if (this.SRLineItemsListArr[index].isvalidateprodid == false) {
        this.isqtycheck = false
        this.SRLineItemsListArr[index].qnty = ""
        this.SRLineItemsListArr[index].qtyErr = ""
        this.SRLineItemsListArr[index].productErr = this.$t('createsr.productIdEANPlaceholder');
        return false;
      }

      if (data.qnty < 1) {
        data.qnty = ''
        this.SRLineItemsListArr[index].isvalidateqnty = false
        return false;
      } else {
        this.SRLineItemsListArr[index].isvalidateqnty = true
      }
      //var reg = new RegExp('^[0-9]+$')
      var reg = new RegExp('^[0-9]+\d*$')
      var result = reg.test(data.qnty)
      if (result == false) {
        // data.qnty = data.qnty.replace(new RegExp(/[^\d]/, 'ig'), "");
        data.qnty = ''
      }

      if (data.qnty == '') {
        this.isqtycheck = false
        this.SRLineItemsListArr[index].qtyErr = this.$t('createsr.qtyPlaceholder');
        this.SRLineItemsListArr[index].isvalidateqnty = false
      }

      // this.input = {
      //   "clientid": this.clientid,
      //   "productid": data.productid.toString(),
      //   "orderid": this.salesOrder.trim()
      // }
      // axios({
      //     method: 'POST',
      //     'url': apiUrl.api_url + 'validateproductQty',
      //     'data': this.input,
      //     headers: {
      //       'Authorization': 'Bearer ' + myStr,
      //     }
      //   })
      //   .then(result => {
      //     if (result.data.errorCode == 0) {

      if (this.toValidateArr.length > 0) {

        for (var i = 0; i < this.toValidateArr.length; i++) {

          if ((data.productid == this.toValidateArr[i].productid) || (data.productname == this.toValidateArr[i].productname)) {

            if ((data.qnty != '') && (data.qnty > Number(this.toValidateArr[i].remaining_qnty))) {
              this.SRLineItemsListArr[index].qtyErr = this.$t('createsr.qtyLessError') + this.toValidateArr[i].remaining_qnty
              this.SRLineItemsListArr[index].isvalidateqnty = false
            } else {
              this.isqtycheck = false
              this.SRLineItemsListArr[index].qtyErr = ""
              this.SRLineItemsListArr[index].isvalidateqnty = true
            }
          }
        }
      } else {
        if (this.isOrderSR == true) {
          this.isfetchResult = true
          this.isqtycheck = false
          this.emptyErrMsg = ''
          this.dublicatemsg = false
          this.SRLineItemsListArr = []
        }
      }
      // } else {
      //   this.SRLineItemsListArr[index].productname = '';
      //   this.SRLineItemsListArr[index].isvalidateqnty = false
      // }
      // }, error => {
      //   console.error(error);
      //   this.$alertify.error("Some thing went wrong");
      // });
    },
    fetchSRLines() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      this.isqtycheck = false
      this.emptyErrMsg = ''
      this.dublicatemsg = false

      if (localStorage.getItem("selectedClient") == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == '') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.listShipmentsData = [];
        return false;
      }
      if (this.salesOrder == '') {
        this.salesOrderErr = this.$t('createsr.salesOrderError');
        return false;
      }
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "orderid": this.salesOrder.trim(),
        "warehouseid" : localStorage.getItem("selectedWarehouse"),
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getOrderProductList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          if (result.data.errorCode == 0) {
            var count = 0
            this.SRLineItemsListArr = []
            if (result.data.data.length > 0) {
              for (var i = 0; i < result.data.data.length; i++) {
                if (result.data.data[i].total_count > 0) {
                  this.SRLineItemsListArr.push({
                    "productname": result.data.data[i].productname,
                    "productid": result.data.data[i].productid,
                    "qnty": result.data.data[i].total_count,
                    "isvalidateqnty": true,
                    "isvalidateprodid": true
                  });
                  count++
                }
              }
            }
            if (count == 0) {
              this.isfetchResult = true
            } else {
              this.isfetchResult = false
            }
            // this.isvalidated = true
            //this.$alertify.success(result.data.msg);
          } else {
            this.$alertify.error(result.data.msg);
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
    createSR() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      if (localStorage.getItem("selectedClient") == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == '') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.listShipmentsData = [];
        return false;
      }
      if (this.salesOrder == '') {
        this.salesOrderErr = this.$t('createsr.salesOrderError');
        return false;
      }
      var inputArr = []
      for (var i = 0; i < this.SRLineItemsListArr.length; i++) {
        if (this.SRLineItemsListArr[i].productid != "" && this.SRLineItemsListArr[i].qnty > 0 && this.dublicatemsg != true) {
          inputArr.push({
            "productid": this.SRLineItemsListArr[i].productid.toString(),
            "quantity": this.SRLineItemsListArr[i].qnty,
          })
        }
      }
      if (inputArr.length == 0) {
        this.emptyErrMsg = this.$t('createsr.emptyErrMsg')
        return false;
      }
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "warehouseid": localStorage.getItem("selectedWarehouse"),
        "orderid": this.salesOrder.trim(),
        "awbno": this.reverseAWB.trim(),
        "email": this.loginuseremail,
        "couriercompany": this.searchchannel,
        "merchantid" : this.merchantid,
        "srDetails": inputArr
      }
      //console.log(this.input);return false;
      if (this.clientRtrnId.trim() != '') {
        this.input.clientreturnid = this.clientRtrnId.trim()
      }
      // console.log(this.input);
      // this.reset(1);
      // console.log(this.searchchannel);
      // return false;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pushSalesReturn',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          if (result.data.errorCode == 0) {
            this.SRLineItemsListArr = [{
              "productname": "",
              "productid": '',
              "qnty": ''
            }]
            // this.isvalidated = true
            this.$alertify.success(result.data.msg);
            this.reset(1);
            // router.push({
            //   name: "srmaster",
            //   params: {
            //     isDisplay: true
            //   },
            //   query: {
            //     clientid: this.clientid,
            //     warehouseid: this.warehouseid,
            //     isDisplay: true
            //   }
            // });
            this.$router.push('/srmaster');
          } else {
            this.$alertify.error(result.data.msg);
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
    check(cnd) {
      var isaddrow = false;
      var iscreateSR = false
      this.dublicatemsg = false;
      for (var i = 0; i < this.SRLineItemsListArr.length; i++) {
        for (var j = i + 1; j < this.SRLineItemsListArr.length; j++) {
          if ((this.SRLineItemsListArr[i].productid == this.SRLineItemsListArr[j].productid) || (this.SRLineItemsListArr[i].productname == this.SRLineItemsListArr[j].productname)) {
            this.dublicatemsg = true
          }
        }
        if (this.SRLineItemsListArr[i].isvalidateqnty && this.SRLineItemsListArr[i].isvalidateprodid) {
          isaddrow = true
          iscreateSR = true
        } else {
          iscreateSR = false
          isaddrow = false
        }
        if (this.SRLineItemsListArr[i].isvalidateprodid == false) {
          this.isqtycheck = false
        } else if (this.SRLineItemsListArr[i].isvalidateqnty == false) {
          this.isqtycheck = true
        } else {
          this.isqtycheck = false
        }
      }
      if (isaddrow && this.dublicatemsg != true && cnd != 1) {
        this.addRow();
      } else if (cnd && iscreateSR && this.dublicatemsg != true) {
        this.createSR();
      }
    },

    ToValidateSRData() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      if (this.invalidOrder == true) {
        return false;
      }

      this.input = {
        "clientid":localStorage.getItem("selectedClient"),
        "orderid": this.salesOrder.trim(),
        "warehouseid" : localStorage.getItem("selectedWarehouse"),
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getOrderProductList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          if (result.data.errorCode == 0) {
            var count = 0
            this.toValidateArr = []
            if (result.data.data.length > 0) {
              for (var i = 0; i < result.data.data.length; i++) {
                if (result.data.data[i].total_count > 0) {
                  this.toValidateArr.push({
                    "productname": result.data.data[i].productname,
                    "productid": result.data.data[i].productid,
                    "remaining_qnty": result.data.data[i].total_count,
                  });
                  count++
                }
              }
            }
            if (count == 0) {
              this.isOrderSR = true
            } else {
              this.isOrderSR = false
            }
          } else {
            this.$alertify.error(result.data.msg);
          }
        }, error => {
          console.error(error);
          this.$alertify.error("Some thing went wrong");
        });
    },
  } // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/createsalesreturn/createsalesreturn.component.js